let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jZYrI")).then(() => parcelRequire('4zL9g'));